export default "__VITE_ASSET__B_H_LA5j__"